var Model = require("../types/Model.js");
var window = require("global");
var navigator = window.navigator;
// eslint-disable-next-line node/no-missing-require
var WebRTC = require("react-native-webrtc");
// eslint-disable-next-line node/no-missing-require
const AsyncStorage = require("@react-native-async-storage/async-storage").default;
var Promise = require("promise");

/**
 * Keeps track of options for input preferences, availability.
 * Also tracks the state of the trunk.
 */
module.exports = Model({
	name: "inputoptions",
	init: init,
	triggers: triggers,

	get_sources: get_sources,
	populatePhoneRTCSources: populatePhoneRTCSources
});

function init() {
	return Promise.all([
		AsyncStorage.getItem("audio_input"),
		AsyncStorage.getItem("video_input"),
	]).then(function (results) {
		var audio = results[0];
		var video = results[1];

		this.push({
			audio: audio,
			video: video,
			sources: {},
			supports_sources: false,
		});

		this.get_sources();
	}.bind(this));
}

function triggers() {
	return {
		"update": handle_trigger_input_update,
		"switch:video": handle_trigger_input_switch,
	};
}

/**
 * Handles triggers for updating the video/audio input preferences.
 * @param  {Object} data Should contain the `video` and `audio` ids to use
 */
function handle_trigger_input_update(data) {
	var audio = data.audio || "";
	var video = data.video || "";

	Promise.all([
		AsyncStorage.setItem("audio_input", audio),
		AsyncStorage.setItem("video_input", video)
	]).then(function(){
		this.extend({
			audio: audio,
			video: video
		});
		this.emit("toast:trigger:show", {
			content: "mediasettings.saved",
		});
	}.bind(this));

	this.emit("usermetrics:trigger:track", "update media settings");
}

function handle_trigger_input_switch(data) {
	var video = data.video;
	if (!video) return;

	AsyncStorage.setItem("video_input", video).then(function () {
		this.extend({
			video: video
		});

		this.emit("buzz:trigger:switch");

	}.bind(this));

	this.emit("usermetrics:trigger:track", "switch video in old calling");
}

/**
 * Populates the list of audio sources if supported
 */
function get_sources() {
	var hasCordova = window.cordova && window.cordova.plugins;
	var hasPhoneRTC = hasCordova && window.cordova.plugins.phonertc;

	if (hasPhoneRTC)
		this.populatePhoneRTCSources();
	if (window.MediaStreamTrack && window.MediaStreamTrack.getSources)
		window.MediaStreamTrack.getSources(handle_got_sources.bind(this));
	if(navigator.mediaDevices && navigator.mediaDevices.enumerateDevices)
		navigator.mediaDevices.enumerateDevices().then(handle_got_sources.bind(this));
	if(WebRTC && WebRTC.MediaStreamTrack && WebRTC.MediaStreamTrack.getSources)
		WebRTC.MediaStreamTrack.getSources().then(handle_got_sources.bind(this));
	if(WebRTC && WebRTC.mediaDevices && WebRTC.mediaDevices.enumerateDevices)
		WebRTC.mediaDevices.enumerateDevices().then(handle_got_sources.bind(this));
}

/**
 * Processes input source list and organizes them by `kind`.
 * Populates the `sources` map in data.
 * Sets `supports_sources` to true.
 * @param  {Array} sources The list of MediaStreamTracks that are available
 */
function handle_got_sources(sources) {
	this.extend({
		supports_sources: true,
		sources: [].slice.call(sources).reduce(function (result, source) {
			var kind = source.kind;
			var section = kind;
			if(kind === "audioinput")
				section = "audio";
			if(kind === "videoinput")
				section = "video";

			var list;
			if (!(list = result[section]))
				list = (result[section] = []);

			var id = source.id || source.deviceId;

			var label = source.label || (section + " #" + list.length);

			list.push({
				value: id,
				name: label
			});

			return result;
		}, {})
	});

	var videoValue = null;
	var audioValue = null;

	var noAudioData = !this.data.audio && this.data.sources.audio;
	var audioNotExists = this.data.audio && this.data.sources.audio && !checkExists(this.data.audio, this.data.sources.audio);

	if(noAudioData || audioNotExists){
		audioValue = this.data.sources.audio[0].value;
		this.extend({
			audio: audioValue
		});
	}

	var noVideoData = !this.data.video && this.data.sources.video;
	var videoNotExists = this.data.video && this.data.sources.video && !checkExists(this.data.video, this.data.sources.video);

	if(noVideoData || videoNotExists){
		var videoSources = this.data.sources.video;
		var frontCamera = findFrontCamera(videoSources) || {};
		videoValue = frontCamera.value || this.data.sources.video[0].value;
		this.extend({
			video: videoValue
		});
	}

	if(videoValue)
		AsyncStorage.setItem("video_input", videoValue);

	if(audioValue)
		AsyncStorage.setItem("audio_input", audioValue);
}

function findFrontCamera(sources){
	return sources.find(function(source){
		return source.name && source.name.toLowerCase().indexOf("front") !== -1;
	});
}

function checkExists(source, sources){
	return sources.reduce(function(acc, src){
		var value = src.value;
		if(source === value) acc = true;
		return acc;
	}, false);
}

function populatePhoneRTCSources() {
	this.extend({
		supports_sources: true,
		sources: {
			audio: [{
				name: "Default",
				value: "default"
			}],
			video: [{
				name: "Front Video",
				value: "Front"
			}, {
				name: "Back Video",
				value: "Back"
			}]
		}
	});
}
